import { useMediaQuery } from 'usehooks-ts'


import { City, useLocationStore } from '@entities/Location'

import { CabinetLink, useAuth } from '@features/auth'
import { CartLink } from '@features/cart'
import { useCartStore } from '@features/cart/model/useCartStore'
import { FavoriteLink } from '@features/favorite'
import { LocationPicker } from '@features/location-picker'
import { Burger } from '@features/mobile-menu'
import { SearchInput } from '@features/search'
import { useAddressStore } from '@features/shipping-methods'
import { SwitchLocale } from '@features/switch-locale'
import { TopMenu } from '@features/top-menu'
import { TopMenuContacts } from '@features/top-menu-contacts'
import { TopMenuNavigation } from '@features/top-menu-navigation'




import { cn } from '@shared/lib/cn'
import Container from '@shared/ui/container'
import Logo from '@shared/ui/logo'

import HeaderWithComponents from './HeaderWithComponents'
import MobileSearchBar from './MobileSearchBar'
import { TabBar } from './TabBar'

import styles from './styles.module.scss'

export default function Header () {
  // const { t: tn } = useTranslation('navigation')
  // const { t: tp } = useTranslation('personal')
  const isTablet = useMediaQuery('(max-width: 1179.9px)')
  const isMobile = useMediaQuery('(max-width: 719.9px)')
  const isShowTabbar = useMediaQuery('(max-width: 1179.9px)')
  // const { openModal } = useModalStore()
  const { currentCity, setCurrentCity } = useLocationStore()
  const { setShop: setCartShop } = useCartStore()
  const { setShopId: setAddressShop, setSelectedAddress } = useAddressStore()
  const { user } = useAuth()
  // const { data } = useMyBonusTotalQuery()
  // const navigate = useNavigate()

  // const match = useMatch('/product/:slug')
  // const isDetailProductPage = !!match?.params.slug?.length

  // const activeCardNumber = data?.myBonus?.bonusCards?.find(
  //   (card) => card?.status === 'active',
  // )?.cardNumber
  // const auhtFlowOrders = useAuthFlow(() => {
  //   navigate(`${URL_CUSTOMER_PROFILE}/${URL_CUSTOMER_ORDERS}`)
  // })
  // const authFlow = useAuthFlow(() =>
  //   navigate(`${URL_CUSTOMER_PROFILE}/${URL_CUSTOMER_LOYALTY}`),
  // )

  // const COUNT = data?.myBonus?.activeBonuses ?? 0

  // const COUNT_FORMATTED = useMemo(() => COUNT.toLocaleString('ru-RU'), [ COUNT ])

  const handleCitySelect = (city: City) => {
    setCurrentCity(city)

    if (city.defaultShop?.id) {
      setAddressShop(city.defaultShop.id)
      setCartShop(city.defaultShop.id)

      /**
       * Just a small hack to skip opening slots modal on first adding to cart
       */
      setSelectedAddress({ isVirtual: true, address: city.defaultShop?.address ?? '' })
    }
  }

  return (
    <>
      {!isTablet && (
        <TopMenu
          leftSection={<LocationPicker currentCity={currentCity} onCitySelect={handleCitySelect} />}
          rightSection={<><TopMenuNavigation /><TopMenuContacts /></>}
          endSection={<><SwitchLocale /></>}
        />
      )}

      <div
        className={cn(styles.header, {
          [styles.auth]: !!user,
        })}
      >
        <Container>
          <div className={styles.header__inner}>
            <div className={styles.header__grid}>
              <Logo className={styles.header__logo} />

              {isMobile ? (
                <MobileSearchBar className={styles.header__search} />
              ) : (
                <SearchInput className={styles.header__search} />
              )}

              {!isTablet && user && (
                <FavoriteLink className={styles.header__favorite} />
              )}

              {isTablet && (<div className={styles.header__location_picker}><LocationPicker currentCity={currentCity} onCitySelect={handleCitySelect} /></div>)}

              <CabinetLink className={styles.header__cabinet} />

              {isTablet && <Burger className={styles.header__burger_menu} />}

              {!isTablet && <CartLink className={styles.header__cart} />}

              {/* {isTablet && isAuthorized && (
                <div className={styles.header__cards}>
                  <div
                    className={cn(styles.header__card, styles.bonus)}
                    onClick={() => {
                      if (!requireRegistration) {
                        openModal(
                          'bonus',
                          <ModalBonus card={activeCardNumber} />,
                          {
                            title: tp('bonus.modal'),
                          },
                        )
                        // зареган в ПЛ
                      }
                      else {
                        // не зареган в ПЛ
                        authFlow()
                      }
                    }}
                  >
                    <h3>{tp('payment.card')}</h3>

                    <div className={styles['header__card-bottom']}>
                      {!requireRegistration && (
                        <span className={styles['header__card-bonus-count']}>
                          {COUNT_FORMATTED}{' '}
                          {tp('bonusHistory.bonusesAbbreviated')}
                        </span>
                      )}

                      <img
                        className={styles['header__card-icon']}
                        src="/icons/barcode.svg"
                        alt=""
                      />
                    </div>
                  </div>
                  <Link
                    to={`${URL_CUSTOMER_PROFILE}/${URL_CUSTOMER_ORDERS}`}
                    className={styles.header__card}
                  >
                    <h3>{tn('orders')}</h3>{' '}
                    <div className={styles['header__card-bottom']}>
                      <img
                        className={styles['header__card-icon']}
                        src="/icons/shopping-cart.svg"
                        alt=""
                      />
                    </div>
                  </Link>
                </div>
              )} */}
            </div>
          </div>

          <HeaderWithComponents disabledParts={[ 'AddressPicker', 'WorkingMode' ]} />
        </Container>
      </div>
      {isShowTabbar && <TabBar withProductQuery={false} />}
    </>
  )
}
